import React from "react";
import NavHeader from "../navs/NavHeader";
import ModalOrder from "../Modals/ModalOrder";


import "./Header.css";

const Header = ({ about, explorer, review, home }) => {
  return (
    <>
      <NavHeader aBout={about} explorer={explorer} Review={review} Home={home} />

      <header>
        <div className="container main" ref={home}>
          <div className="row align-items-center">
            <div className="col-md-6 info">
              <h1 className="title">
                Good food choices are good investments.
              </h1>
              <p className="my-4">
                Every bite tells a story of quality, passion, and care.  
                We serve dishes made from the freshest ingredients —  
                crafted to satisfy your hunger and warm your heart.
              </p>
              <ModalOrder />
            </div>
            <div className="col-md-6 header-image"></div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;

